import React from "react";
import { Field } from "redux-form";

import { Icon, ReduxControls } from "rhombus-react";

const ICONS_BY_TYPE = {
	Text: "far fa-font-case",
	Image: "far fa-image-polaroid",
};

export default function VariableRow(props){
	const {
		variable,
		isDisabled,
		tip = "",
	} = props;

	const { name, type } = variable || {};

	return (
		<div
			className="variable-selection-row"
			data-tip={tip}
			data-place="left"
			data-multiline={true}
		>
			<Field
				name={`variables.${name}`}
				component={ReduxControls.Checkbox}
				className={`inverted-check cypress-gen-ai-variable-${name.toLowerCase()}-field`}
				label={name}
				useValue
				disabled={isDisabled}
			/>
			<Icon name={ICONS_BY_TYPE[type]} />
		</div>
	);
}

VariableRow.displayName = "VariableRow";
